import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, map } from "rxjs";
import { DemoLimit } from "../core/model/DemoLimit";
import { HttpClient } from "@angular/common/http";
import { brdCatchError } from "../shared/message-utils";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class LimitService {
  private apiUrl: string = environment.API + "/DemoInstance";
  private limitSubject = new BehaviorSubject<DemoLimit | null>(null);
  limits$ = this.limitSubject.asObservable();

  constructor(private http: HttpClient) {}

  getLimit(group?: string): Observable<DemoLimit> {
    return this.http
      .get<DemoLimit>(this.apiUrl + "/limit", {
        params: group ? { group } : undefined
      })
      .pipe(
        brdCatchError(),
        map(res => {
          this.limitSubject.next(res);
          return res;
        })
      );
  }

  increaseCurrentUsage(): void {
    const limit = this.limitSubject.value!;

    this.limitSubject.next({
      ...limit,
      currentUsage: limit.currentUsage + 1
    });
  }

  decreaseCurrentUsage(): void {
    const limit = this.limitSubject.value!;

    this.limitSubject.next({
      ...limit,
      currentUsage: limit.currentUsage - 1
    });
  }
}
